/**
 * Barra lateral de navegación (Sidebar) para el panel de administración.
 * Gestiona los enlaces a las diferentes secciones administrativas y el cierre de sesión.
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * @param {Object} props
 * @param {boolean} props.isOpen - Indica si el sidebar está abierto en dispositivos móviles.
 * @param {Function} props.toggle - Función para alternar el estado de apertura del sidebar.
 */
const AdminSidebar = ({ isOpen, toggle }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Función para limpiar el almacenamiento local y redirigir al inicio de sesión
    const handleLogout = () => {
        localStorage.clear();
        navigate("/Login");
    };

    // Verifica si una ruta es la activa para resaltar el enlace en la UI
    const isActive = (path) => location.pathname === path;

    return (
        <aside className={`admin-sidebar ${isOpen ? 'mobile-open' : ''}`}>
            {/* Botón para cerrar el sidebar en móviles */}
            <button className="mobile-nav-toggle position-absolute top-0 end-0 m-2 d-md-none text-white" onClick={toggle}>
                <i className="bi bi-x-lg"></i>
            </button>

            <div className="sidebar-brand">
                <i className="bi bi-shield-lock-fill"></i>
                <span>GEOHCX Admin</span>
            </div>

            <nav className="sidebar-nav">
                <button
                    className={`sidebar-link ${isActive("/DashboardAdmin") ? "active" : ""}`}
                    onClick={() => navigate("/DashboardAdmin")}
                >
                    <i className="bi bi-grid-fill"></i>
                    <span>Panel General</span>
                </button>

                <button
                    className={`sidebar-link ${isActive("/New") ? "active" : ""}`}
                    onClick={() => navigate("/New")}
                >
                    <i className="bi bi-person-plus-fill"></i>
                    <span>Nuevo Usuario</span>
                </button>

                <button
                    className={`sidebar-link ${isActive("/AdminCases") ? "active" : ""}`}
                    onClick={() => navigate("/AdminCases")}
                >
                    <i className="bi bi-clipboard2-pulse"></i>
                    <span>Gestión de Casos</span>
                </button>

                <button
                    className={`sidebar-link ${isActive("/AdminPatients") ? "active" : ""}`}
                    onClick={() => navigate("/AdminPatients")}
                >
                    <i className="bi bi-people-fill"></i>
                    <span>Pacientes Registrados</span>
                </button>

                <button
                    className={`sidebar-link ${isActive("/AdminAccessRequests") ? "active" : ""}`}
                    onClick={() => navigate("/AdminAccessRequests")}
                >
                    <i className="bi bi-person-lines-fill"></i>
                    <span>Solicitudes de Acceso</span>
                </button>

                <button
                    className={`sidebar-link ${isActive("/AdminNotifications") ? "active" : ""}`}
                    onClick={() => navigate("/AdminNotifications")}
                >
                    <i className="bi bi-bell-fill"></i>
                    <span>Configuración de Alertas</span>
                </button>
            </nav>

            

                <button
                    className={`sidebar-link ${isActive("/CambiarPassword") ? "active" : ""}`}
                    onClick={() => navigate("/CambiarPassword")}
                >
                    <i className="bi bi-shield-lock-fill"></i>
                    <span>Cambiar Contraseña</span>
                </button>

                <button className="btn btn-danger btn-sm border-secondary" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-1"></i>
                    Cerrar Sesión
                </button>

        
        </aside>
    );
};

export default AdminSidebar;
